export const SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE'
export const HIDE_TOAST_MESSAGE = 'HIDE_TOAST_MESSAGE'
export const SET_USER_AUTHENTICATED = 'SET_USER_AUTHENTICATED'
export const SET_USER_INFORMATION = 'SET_USER_INFORMATION'
export const HANDLE_API_ALERTS = 'HANDLE_API_ALERTS'
export const SET_AUTHENTICATION_INITIALIZED = 'SET_AUTHENTICATION_INITIALIZED'
